import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Empty, Spin } from "antd";

import EventCard from "../Events/EventCard";
import {
  fetchAllEvents,
  selectEvents,
  selectFetchAllEventsStatus,
  selectFetchAllEventsError,
} from "../../redux/eventSlice";

export default function UpcomingEventsSection() {
  const dispatch = useDispatch();
  const allEvents = useSelector(selectEvents);
  const loading = useSelector(selectFetchAllEventsStatus);
  const error = useSelector(selectFetchAllEventsError);

  useEffect(() => {
    dispatch(fetchAllEvents());
  }, [dispatch]);

  const upcomingEvents = (allEvents?.data || []).slice(0, 4);

  return (
    <section className="homeV2Section homeV2SectionCompact">
      <div className="container">
        <div className="homeV2SectionHeader">
          <h2 className="homeV2SectionTitle">Upcoming Events</h2>
          <Link className="homeV2ViewLink" to="/discover-events">
            View All Events
          </Link>
        </div>
        <Spin spinning={loading === "loading"} tip="Loading upcoming events...">
          {!error && upcomingEvents.length > 0 ? (
            <div className="upcomingEventsList">
              {upcomingEvents.map((event) => (
                <EventCard event={event} key={event.id} layout="upcoming" />
              ))}
            </div>
          ) : (
            <Empty description="No upcoming events found" />
          )}
        </Spin>
      </div>
    </section>
  );
}
